import {
  LayoutDashboard,
  Calculator,
  Target,
  FileText,
  Search,
  Package,
  Building2,
  History,
  Settings,
  Users,
  type LucideIcon,
} from 'lucide-react';

/**
 * O menu segue A DECISÃO, não o modelo de dados.
 *
 * Você abre o ProfitLens para decidir uma compra, não para navegar num
 * cadastro — então painel e oportunidades vêm primeiro, e produto e fornecedor
 * ficam onde você só vai quando precisa cadastrar algo.
 *
 * Dez entradas numa lista plana obrigam a ler tudo toda vez. Agrupadas em
 * quatro blocos, você acerta o destino pelo bloco e só depois lê o item.
 */
export interface ItemMenu {
  id: string;
  rotulo: string;
  caminho: string;
  icone: LucideIcon;
  soAdministrador?: boolean;
  /** Chave do resumo do painel que alimenta o contador. */
  contador?: 'cotacoesAguardando' | 'oportunidadesViaveis' | 'itensAguardandoRevisao';
}

export interface GrupoMenu {
  id: string;
  rotulo: string;
  itens: ItemMenu[];
}

export const MENU: GrupoMenu[] = [
  {
    id: 'decidir',
    rotulo: 'Decidir',
    itens: [
      { id: 'painel', rotulo: 'Painel', caminho: '/', icone: LayoutDashboard, contador: 'itensAguardandoRevisao' },
      { id: 'viabilidade', rotulo: 'Viabilidade', caminho: '/viabilidade', icone: Calculator },
      { id: 'oportunidades', rotulo: 'Oportunidades', caminho: '/oportunidades', icone: Target, contador: 'oportunidadesViaveis' },
    ],
  },
  {
    id: 'levantamento',
    rotulo: 'Levantamento',
    itens: [
      { id: 'cotacoes', rotulo: 'Cotações', caminho: '/cotacoes', icone: FileText, contador: 'cotacoesAguardando' },
      { id: 'pesquisa', rotulo: 'Pesquisa de mercado', caminho: '/pesquisa', icone: Search },
    ],
  },
  {
    id: 'cadastro',
    rotulo: 'Cadastro',
    itens: [
      { id: 'mercadorias', rotulo: 'Mercadorias', caminho: '/mercadorias', icone: Package },
      { id: 'fornecedores', rotulo: 'Fornecedores', caminho: '/fornecedores', icone: Building2 },
    ],
  },
  {
    id: 'sistema',
    rotulo: 'Sistema',
    itens: [
      { id: 'historico', rotulo: 'Histórico', caminho: '/historico', icone: History },
      { id: 'configuracoes', rotulo: 'Configurações', caminho: '/configuracoes', icone: Settings, soAdministrador: true },
      { id: 'usuarios', rotulo: 'Usuários', caminho: '/usuarios', icone: Users, soAdministrador: true },
    ],
  },
];
